import moment from 'moment';

/**
 * 投保後查詢資料
 * @returns {Object}
 */
const state = () => ({
  estimateId: null,
  assuredId: null,
  loadedAt: null, // 最後從 api 更新的時間
  progressInfo: {
    //牌照號碼
    tagID: null,
    //要保日期
    entryDate: null,
    //收到保費日期
    payDate: null,
    //處理狀態
    dealStatusDescript: null,
    //保單型式
    policyType: null,
    //保單寄送日
    policyOutTrans: null,
    //強制證號
    compelCardId: null,
    //文件收訖日
    fileUpdateDate: null,
    //簽名確認結果
    fileVerifyStatus: null,
    //要保書狀態
    applicationStatus: null,
    //是否顯示要保書下載
    showProposal: null,
    isRenew: null,
  },
  //繳費資訊
  payInfo: {
    //繳費期限
    deadline: null,
    //繳費方式
    payWay: null,
    //銀行代碼(選擇ATM才會有)
    sortCode: null,
    //匯款帳號(選擇ATM才會有)
    orderID: null,
    //入帳時間(已付款才會有)
    payDate: null,
    //是否可繳費
    canPay: null,
    //金額
    amount: null,
    //允許的持卡人清單
    allowHolders: null,
  },
  //檔案上傳相關資訊
  fileInfo: {
    //已上傳的檔案清單
    fileList: null, //Key：檔名、Value：上傳時間
    //是否可上傳檔案
    canUpload: null,
  },
  //可用的繳費方式(PayInfo.CanPay為true時才有值)
  payWays: null, //Key：繳費方式代號，Value：繳費方式名稱
  //有值時需導向指定URL
  redirectUrl: null,
});

const actions = {};

const getters = {};

const mutations = {
  /**
   * 設定初始資料
   * @param state
   * @param payload
   */
  active(state, payload) {
    state.assuredId = payload.assuredId;
    state.estimateId = payload.estimateId;
  },
  /**
   * 寫入從 api 下載回來的內容，及寫入時間
   * @param state
   * @param payload
   */
  setDataFromApi(state, payload) {
    state.redirectUrl = payload.RedirectUrl;

    state.fileInfo.canUpload = payload.FileInfo.CanUpload.toLowerCase();
    state.fileInfo.fileList = payload.FileInfo.FileList;

    state.payInfo.allowHolders = payload.PayInfo.AllowHolders;
    state.payInfo.amount = payload.PayInfo.Amount;
    state.payInfo.canPay = payload.PayInfo.CanPay.toLowerCase();
    state.payInfo.deadline = payload.PayInfo.Deadline;
    state.payInfo.orderID = payload.PayInfo.OrderID;
    state.payInfo.payDate = payload.PayInfo.PayDate;
    state.payInfo.payWay = payload.PayInfo.PayWay;
    state.payInfo.sortCode = payload.PayInfo.SortCode;

    state.payWays = payload.PayWays;

    state.progressInfo.applicationStatus =
      payload.ProgressInfo.ApplicationStatus;
    state.progressInfo.compelCardId = payload.ProgressInfo.CompelCardId;
    state.progressInfo.dealStatusDescript =
      payload.ProgressInfo.DealStatusDescript;
    state.progressInfo.entryDate = payload.ProgressInfo.EntryDate;
    state.progressInfo.fileUpdateDate = payload.ProgressInfo.FileUpdateDate;
    state.progressInfo.fileVerifyStatus = payload.ProgressInfo.FileVerifyStatus;
    state.progressInfo.payDate = payload.ProgressInfo.PayDate;
    state.progressInfo.policyOutTrans = payload.ProgressInfo.PolicyOutTrans;
    state.progressInfo.policyType = payload.ProgressInfo.PolicyType;
    state.progressInfo.showProposal = payload.ProgressInfo.ShowProposal.toLowerCase();
    state.progressInfo.tagID = payload.ProgressInfo.TagID;
    state.progressInfo.isRenew = payload.ProgressInfo.IsRenew;

    state.loadedAt = moment().format();
  },
  /**
   * 上傳的檔案
   * @param {*} state
   * @param {*} payload
   */
  setFileList(state, payload) {
    state.fileInfo.fileList = payload;
  },
  /**
   * 清除資料
   * @param {*} state
   */
  clear(state) {
    state.estimateId = null;
    state.assuredId = null;
    state.loadedAt = null;
    state.redirectUrl = null;

    state.fileInfo.canUpload = false;
    state.fileInfo.fileList = null;

    state.payInfo.allowHolders = null;
    state.payInfo.amount = null;
    state.payInfo.canPay = null;
    state.payInfo.deadline = null;
    state.payInfo.orderID = null;
    state.payInfo.payDate = null;
    state.payInfo.payWay = null;
    state.payInfo.sortCode = null;

    state.payWays = null;

    state.progressInfo.applicationStatus = null;
    state.progressInfo.compelCardId = null;
    state.progressInfo.dealStatusDescript = null;
    state.progressInfo.entryDate = null;
    state.progressInfo.fileUpdateDate = null;
    state.progressInfo.fileVerifyStatus = null;
    state.progressInfo.payDate = null;
    state.progressInfo.policyOutTrans = null;
    state.progressInfo.policyType = null;
    state.progressInfo.showProposal = null;
    state.progressInfo.isRenew = null;
    state.progressInfo.tagID = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
